<template>
  <div
    v-if="isAutoRedirectingToFordPro"
    class="ford-pro-redirecting-overlay"
    data-qa="ford-pro-redirecting-overlay"
  >
    <div class="ford-pro-redirecting-overlay__content">
      <LoadingSpinner :size="64" :width="5" />
      <p class="ford-pro-redirecting-overlay__message">
        {{ loadingMessage }}
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import LoadingSpinner from '@/components/utility-components/LoadingSpinner';

export default {
  name: 'FordProRedirectingOverlay',
  components: { LoadingSpinner },
  computed: {
    ...mapGetters('fpgConfiguration', ['isAutoRedirectingToFordPro']),
    loadingMessage() {
      const translated = this.$t('common.loading');
      return translated === 'common.loading' ? 'Loading' : translated;
    },
  },
};
</script>

<style scoped>
.ford-pro-redirecting-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ford-pro-redirecting-overlay__content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
}

.ford-pro-redirecting-overlay__message {
  font-size: 16px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.87);
  margin: 0;
}
</style>
